import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import NotificationsIcon from '@mui/icons-material/Notifications';
import Badge from '@mui/material/Badge';
import Popover from '@mui/material/Popover';
import { useNotifications } from '../../contexts/NotificationContext';
import { useTheme } from '../../contexts/ThemeContext';
import { NotificationDropdown } from './NotificationDropdown';

export const NotificationBell = () => {
  const { totalUnread, coursesWithUnread, pluginEnabled, refreshUnread } = useNotifications();
  const theme = useTheme();
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = Boolean(anchorEl);

  if (!pluginEnabled) {
    return null;
  }

  const isDark = theme && theme.mode === 'dark';

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelectCourse = (courseId, unreadCount) => {
    handleClose();

    if (unreadCount && typeof window !== 'undefined') {
      window.dispatchEvent(
        new CustomEvent('tipddy:message_read', {
          detail: {
            courseId: Number(courseId),
            unreadCount: Number(unreadCount),
          },
        })
      );
    }

    navigate(`/detailcourse/${courseId}?tab=chat&t=${Date.now()}`);
  };

  return (
    <>
      <div
        className="modo_dia"
        onClick={handleClick}
        style={{
          backgroundColor: theme?.mode === 'light' ? '#f5f5f5' : '#333',
          cursor: 'pointer',
        }}
        title="Mensajes de cursos"
      >
        <Badge
          badgeContent={totalUnread}
          color="error"
          max={99}
          invisible={totalUnread === 0}
          sx={{
            '& .MuiBadge-badge': {
              fontSize: '10px',
              height: '16px',
              minWidth: '16px',
              fontWeight: 'bold',
              top: '-2px',
              right: '-2px',
            },
          }}
        >
          <NotificationsIcon
            sx={{
              fontSize: 22,
              fill: theme?.mode === 'light' ? '#2d4662' : '#ffffff',
            }}
          />
        </Badge>
      </div>

      <Popover
        open={isOpen}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          elevation: 12,
          sx: {
            width: { xs: '92vw', sm: 560, md: 600 },
            borderRadius: '20px',
            mt: 2,
            overflow: 'hidden',
            fontFamily: "'Outfit', -apple-system, BlinkMacSystemFont, sans-serif",
            backgroundColor: isDark ? '#1e293b' : '#ffffff',
            border: isDark ? '1px solid #334155' : '1px solid #cbd5e1',
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.22), 0 12px 24px -6px rgba(0, 0, 0, 0.12)',
          },
        }}
      >
        <NotificationDropdown
          coursesWithUnread={coursesWithUnread}
          totalUnread={totalUnread}
          onSelectCourse={handleSelectCourse}
          isDark={isDark}
        />
      </Popover>
    </>
  );
};
